export const INFORMES_HOME_PATH = '/informes-home'
export const INFORMES_CONCILIACION_PATH = '/informes-conciliacion'

/** Home and Header entry for ROLE_ADMIN. */
export const INFORMES_NAV_VISIBLE = true

export const canAccessInformes = (role) => role === 'ROLE_ADMIN'

export const canSeeInformesNav = (role) =>
    INFORMES_NAV_VISIBLE && canAccessInformes(role)

export const getInformesHubItems = () => [
    {
        title: 'Conciliación',
        path: INFORMES_CONCILIACION_PATH,
    },
]

export const RESULTADO_CUMPLIO = 'Cumplio'
export const RESULTADO_A_REVISAR = 'A revisar'

export const formatConciliacionNumber = (value) => {
    if (value == null || value === '' || Number.isNaN(Number(value))) {
        return '0.00'
    }
    return Number(value).toFixed(2)
}

export const formatConciliacionPercent = (value) => {
    if (value == null || value === '' || Number.isNaN(Number(value))) {
        return '—'
    }
    return `${Number(value).toFixed(2)}%`
}

export const conciliacionResultadoClass = (resultado) => {
    if (resultado === RESULTADO_CUMPLIO) {
        return 'informe-conciliacion-resultado informe-conciliacion-resultado--cumplio'
    }
    if (resultado === RESULTADO_A_REVISAR) {
        return 'informe-conciliacion-resultado informe-conciliacion-resultado--revisar'
    }
    return 'informe-conciliacion-resultado'
}

export const visibleConciliacionFilas = (filas, mostrarTodos) => {
    const rows = Array.isArray(filas) ? filas : []
    if (mostrarTodos) return rows
    return rows.filter((fila) => fila && fila.resultado === RESULTADO_A_REVISAR)
}
